import { render, staticRenderFns } from "./partytransfer.vue?vue&type=template&id=0ebee90c&"
import script from "./partytransfer.vue?vue&type=script&lang=js&"
export * from "./partytransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports